import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1750cdd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "xag-flex-1 content xag-flex-vertical" }
const _hoisted_3 = { class: "eveluate-date" }
const _hoisted_4 = { class: "content-box" }
const _hoisted_5 = { class: "star-box" }
const _hoisted_6 = { class: "text-area-box xag-flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", {
    class: "detail-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_ctx.pagePaddingTop)}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, { title: "评价内容" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "评价时间：" + _toDisplayString(_ctx.eveluateData.created_at), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_rate, {
            modelValue: _ctx.eveluateData.stars,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eveluateData.stars) = $event)),
            size: 24,
            "allow-half": "",
            color: "rgba(249, 195, 3, 1)",
            "void-icon": "star",
            "void-color": "rgba(229, 229, 229, 1)"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.eveluateData.describe,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eveluateData.describe) = $event)),
            modelModifiers: { trim: true },
            rows: "6",
            maxlength: "150",
            "show-word-limit": "",
            type: "textarea",
            placeholder: ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ], 4))
}